module.exports = __webpack_public_path__ + "img/sunny.325f1479.png";